import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import Contact from './pages/Contact';
import About from './pages/About';
import Events from './pages/Events';
import MembersManagement from './pages/MembersManagement';
import Members from './pages/Members';
import NewsCategory from './pages/News/NewsCategory';
import NewsManagement from './pages/NewsManagement';
import ContactManagement from './pages/ContactManagement';
import Gallery from './pages/Gallery';
import Career from './pages/Career';
import MembershipApplication from './pages/MembershipApplication';
import MembershipManagement from './pages/MembershipManagement';
import JobManagement from './pages/JobManagement';
import JobApplications from './pages/JobApplications';
import CourtRoomManagement from './pages/CourtRoomManagement';
import EventManagement from './pages/EventManagement';
import GalleryManagement from './pages/GalleryManagement';
import ManagingCommitteeManagement from './pages/ManagingCommitteeManagement';
import ManagingCommittee from './pages/ManagingCommittee';
import FAQManagement from './pages/FAQManagement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/events" element={<Events />} />
              <Route path="/members" element={<Members />} />
              <Route path="/news/*" element={<NewsCategory />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/career" element={<Career />} />
              <Route path="/membership-application" element={<MembershipApplication />} />
              <Route path="/managing-committee" element={<ManagingCommittee />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/members-management" 
                element={
                  <ProtectedRoute>
                    <MembersManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/news-management" 
                element={
                  <ProtectedRoute>
                    <NewsManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/contact-management" 
                element={
                  <ProtectedRoute>
                    <ContactManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/membership-management" 
                element={
                  <ProtectedRoute>
                    <MembershipManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/job-management" 
                element={
                  <ProtectedRoute>
                    <JobManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/event-management" 
                element={
                  <ProtectedRoute>
                    <EventManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/job-applications/:jobId" 
                element={
                  <ProtectedRoute>
                    <JobApplications />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/court-room-management" 
                element={
                  <ProtectedRoute>
                    <CourtRoomManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/gallery-management" 
                element={
                  <ProtectedRoute>
                    <GalleryManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/managing-committee-management" 
                element={
                  <ProtectedRoute>
                    <ManagingCommitteeManagement />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/faq-management" 
                element={
                  <ProtectedRoute>
                    <FAQManagement />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
